var _module_exports = "<uib-accordion close-others=\"true\"><uib-accordion-group><uib-accordion-heading><ec-schema-header schema=\"vm.schema\"></ec-schema-header></uib-accordion-heading><form name=\"vm.schemaForm\"><div data-sf-schema=\"vm.schema\" data-sf-form=\"vm.form\" data-sf-model=\"vm.model\"></div></form></uib-accordion-group></uib-accordion>";;
var path = '/app/vendor/ec-fe-bo-template/dist/views/schema/schema.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/vendor/ec-fe-bo-template/dist/views/schema/schema.html
// module id = 913
// module chunks = 0